import { render } from "./RatioPieChart.vue?vue&type=template&id=617c2505"
import script from "./RatioPieChart.vue?vue&type=script&lang=js"
export * from "./RatioPieChart.vue?vue&type=script&lang=js"

import "./RatioPieChart.vue?vue&type=style&index=0&id=617c2505&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__